// extracted by mini-css-extract-plugin
module.exports = {"TeamMemberList":"TeamMemberList_TeamMemberList__3tziw","TeamMemberListTitle":"TeamMemberList_TeamMemberListTitle__XWQWI"};